export default {
    authTokenBM: 'oauth/token',
    property: '/api/property',
};
